// extracted by mini-css-extract-plugin
export var blue = "_4a-h";
export var brand = "_4a-d";
export var darkGrey = "_4a-g";
export var disabled = "_4a-6";
export var disabledSubtle = "_4a-7";
export var error = "_4a-8";
export var green = "_4a-i";
export var grey = "_4a-f";
export var icon = "_4a-0";
export var inherit = "_4a-c";
export var lightGrey = "_4a-e";
export var orange = "_4a-k";
export var pink = "_4a-m";
export var primary = "_4a-1";
export var purple = "_4a-n";
export var quaternary = "_4a-4";
export var quinary = "_4a-5";
export var red = "_4a-l";
export var secondary = "_4a-2";
export var success = "_4a-b";
export var tertiary = "_4a-3";
export var warning = "_4a-9";
export var warningSecondary = "_4a-a";
export var white = "_4a-o";
export var yellow = "_4a-j";